export default "__VITE_ASSET__6Of_3Ik7__"